import React, { FC } from 'react';
import NumberFormat from 'react-number-format';

interface CustomNumberFormatProps {
  value: string | number;
  suffix?: string;
}

const defaultProps = {
  suffix: '',
};

export const CustomNumberFormat: FC<CustomNumberFormatProps> = ({ value, suffix }) => {
  return (
    <NumberFormat
      value={value}
      thousandSeparator={' '}
      suffix={` ${suffix}`}
      displayType="text"
      decimalScale={2}
      decimalSeparator="."
      fixedDecimalScale
    />
  );
};

CustomNumberFormat.defaultProps = defaultProps;
